/**
 * @generated SignedSource<<6d195ab32710ee80c6ffa3a46377cc37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopicsAdminQuery$variables = Record<PropertyKey, never>;
export type TopicsAdminQuery$data = {
  readonly currentStore: {
    readonly id: string;
    readonly topics: ReadonlyArray<{
      readonly id: string;
      readonly isPrivate: boolean | null;
      readonly " $fragmentSpreads": FragmentRefs<"TopicsAdminTopicListItem_storeTopic">;
    }> | null;
  } | null;
};
export type TopicsAdminQuery = {
  response: TopicsAdminQuery$data;
  variables: TopicsAdminQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicsAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TopicsAdminTopicListItem_storeTopic"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TopicsAdminQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "currentStore",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreTopic",
            "kind": "LinkedField",
            "name": "topics",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "784d983cae89f7615b2d905b55b3b2ba",
    "id": null,
    "metadata": {},
    "name": "TopicsAdminQuery",
    "operationKind": "query",
    "text": "query TopicsAdminQuery {\n  currentStore {\n    id\n    topics {\n      id\n      isPrivate\n      ...TopicsAdminTopicListItem_storeTopic\n    }\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment TopicsAdminTopicListItem_storeTopic on StoreTopic {\n  id\n  name\n  isPrivate\n  teams {\n    id\n    name\n    ...AHTeamIconCircle\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3b39d224ebcecc879227bbe39d47ace";

export default node;
